import { z } from "zod";

export const uidPinSchema = z.object({
  uid: z
    .string()
    .min(1, { message: "UID is required" })
    .regex(/^[a-zA-Z0-9]+$/, { message: "UID can only be alphanumeric" })
    .min(6, { message: "UID must be 6 characters" })
    .max(8, { message: "UID must be 8 characters" }),
  pin_number: z
    .string()
    .min(1, { message: "PIN is required" })
    .min(4, { message: "PIN must be 4 digits" })
    .max(4, { message: "PIN must be 4 digits" })
    .regex(/^\d+$/, { message: "PIN must be a number" }),
});

export type UidPinModel = z.infer<typeof uidPinSchema>;
